/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:1199px){.toggle-wrapper[_ngcontent-%COMP%]{width:initial}.popup[_ngcontent-%COMP%]{width:400px}}@media (max-width:599px){.favourites[_ngcontent-%COMP%]{right:32%;bottom:0;position:absolute}.popup[_ngcontent-%COMP%]{position:absolute;width:95vw;margin:0 2.5%;top:-20px}.popup[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{border-radius:8px;padding:15px 30px}}"];
export { styles as styles };
